export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Focus", href: "#focus" },
  { label: "Practices", href: "#practices" },
  { label: "Leaflets", href: "#leaflets" },
  { label: "Contact", href: "#contact" },
];

export const MARQUEE_ITEMS = [
  "Glaucoma Management",
  "Complex Cataract Surgery",
  "Kingston",
  "Ocho Rios",
  "Montego Bay",
  "Patient Information Leaflets",
];

export const FOCUS_AREAS = [
  {
    number: "I",
    title: "Glaucoma Management",
    body: "Comprehensive care across all forms of glaucoma: primary open-angle, angle closure, secondary, and refractory. From early diagnosis through surgical intervention when needed, including trabeculectomy, tube shunts, and angle surgery.",
  },
  {
    number: "II",
    title: "Complex Cataract Surgery",
    body: "Cataract surgery for straightforward and higher-complexity cases, with an emphasis on safe, effective outcomes tailored to each patient.",
  },
];

export const PRACTICES = [
  {
    id: "uhwi",
    name: "University Hospital of the West Indies (UHWI)",
    city: "Kingston",
    address: "Mona, Kingston 7",
    phones: ["(876) 927-1620-9", "(876) 927-1630-9"],
    note: "Referral only",
  },
  {
    id: "ideal-vision",
    name: "Ideal Vision",
    city: "Kingston",
    address: "1 Lismore Ave, Kingston 5",
    detail: "Entrance on Old Hope Road, beside Home and Things",
    phones: ["(876) 672-1690", "(876) 488-6083"],
    email: "info@idealvisionja.com",
  },
  {
    id: "trivision",
    name: "TriVision Ophthalmics",
    city: "Ocho Rios",
    address: "Shop #20, White River North Commercial Complex, Ocho Rios",
    phones: ["(876) 974-2242", "(876) 868-8890 (WhatsApp)"],
    email: "info@trivisionja.com",
  },
  {
    id: "vision-and-things",
    name: "Vision and Things",
    city: "Montego Bay",
    address: "15 East St, Montego Bay, St James",
    phones: ["(876) 807-5411"],
  },
];

export const LEAFLET_GROUPS = [
  {
    group: "Understanding Glaucoma",
    items: [
      { title: "Glaucoma: A Guide (Glaucoma UK)", file: "glaucoma-uk-a-guide.pdf" },
      { title: "Primary Open-Angle Glaucoma (Glaucoma UK)", file: "glaucoma-uk-primary-open-angle-glaucoma.pdf" },
      { title: "Primary Angle-Closure Glaucoma (Glaucoma UK)", file: "glaucoma-uk-primary-angle-closure-glaucoma.pdf" },
      { title: "Ocular Hypertension (Glaucoma UK)", file: "glaucoma-uk-ocular-hypertension.pdf" },
      { title: "Secondary Glaucomas (Glaucoma UK)", file: "glaucoma-uk-secondary-glaucomas.pdf" },
      { title: "Glaucoma in Babies and Children (Glaucoma UK)", file: "glaucoma-uk-in-babies-and-children.pdf" },
    ],
  },
  {
    group: "Living With Glaucoma",
    items: [
      { title: "Understanding and Living With Glaucoma", file: "understanding-and-living-with-glaucoma.pdf" },
      { title: "Putting In Your Eye Drops (Easy Read)", file: "putting-in-your-eye-drops-easy-read.pdf" },
      { title: "Driving and Glaucoma (Glaucoma UK)", file: "glaucoma-uk-driving-and-glaucoma.pdf" },
      { title: "Glaucoma and Your Relatives (Glaucoma UK)", file: "glaucoma-uk-and-your-relatives.pdf" },
    ],
  },
  {
    group: "Related Eye Conditions",
    items: [
      { title: "Dry Eye Disease (Glaucoma UK)", file: "glaucoma-uk-dry-eye-disease.pdf" },
      { title: "Blepharitis (Glaucoma UK)", file: "glaucoma-uk-blepharitis.pdf" },
    ],
  },
  {
    group: "Cataract Surgery",
    items: [
      { title: "Understanding Cataracts", file: "understanding-cataracts.pdf" },
    ],
  },
  {
    group: "Angle Surgery",
    items: [
      { title: "iStent infinite Patient Brochure", file: "istent-inject-patient-brochure.pdf" },
    ],
  },
  {
    group: "Laser Procedures",
    items: [
      { title: "Selective Laser Trabeculoplasty (SLT)", file: "selective-laser-trabeculoplasty.pdf" },
      { title: "Cyclodiode Laser Treatment", file: "cyclodiode-laser.pdf" },
    ],
  },
  {
    group: "Trabeculectomy",
    items: [
      { title: "Trabeculectomy (Glaucoma UK)", file: "glaucoma-uk-trabeculectomy.pdf" },
    ],
  },
  {
    group: "Tube Shunts",
    items: [
      { title: "Aqueous Shunts (Glaucoma UK)", file: "glaucoma-uk-aqueous-shunts.pdf" },
      { title: "Paul Glaucoma Implant Patient Brochure", file: "paul-glaucoma-implant-patient-brochure.pdf" },
      { title: "Preserflo MicroShunt Patient Brochure", file: "preserflo-microshunt-patient-brochure.pdf" },
    ],
  },
];
